module.exports = __webpack_public_path__ + "static/face_detector-58dd75d1164248e20fddbb4ebbd84bec.jpg";